import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading';
import IconButton from '@cotyorg/ccx-molecules/IconButton';
import Button from '@cotyorg/ccx-atoms/Button';
import FilterAccordion from '../FilterAccordion';

export const getOnClickClearAll = ({ setSelectedFilters, closeModal }) => () => {
  setSelectedFilters();
  closeModal();
};

// Need to use class so that we can store the original selected
// filters in componentWillMount so that we can revert back to
// them if the modal is closed without the user clicking "Apply"
// istanbul ignore next
class FilterModal extends PureComponent {
  componentWillMount() {
    const { selectedFilters = [] } = this.props;
    this.originalSelectedFilters = [...selectedFilters];
  }

  onCloseClick = () => {
    const { setSelectedFilters, closeModal } = this.props;

    // reset the selected filters to what they were before
    // the modal was opened
    setSelectedFilters(this.originalSelectedFilters);
    closeModal();
  }

  render() {
    const {
      closeModal,
      categories,
      toggleFilter,
      setSelectedFilters,
      accordionMinusIconSrc,
      accordionPlusIconSrc,
      modalHeadingText,
      modalCloseIconSrc,
      clearAllText = '',
      modalFormButtonText = '',
      dataTestClearAll = '',
      dataTestApply = '',
      isOpen,
    } = this.props;

    return (
      <Fragment>
        <div className="filter__modal-header grid-x align-right align-middle">
          <Heading extraClass="cell xsmall-12 filter__modal-heading" level={1}>{modalHeadingText}</Heading>
          <div className="cell xsmall-2">
            <IconButton
              extraClass="filter__modal-close-button"
              iconExtraClass="filter__modal-close-button-icon"
              iconSrc={modalCloseIconSrc}
              size="small"
              onClick={this.onCloseClick}
            />
          </div>
        </div>
        <div className="filter__modal-body">
          <FilterAccordion
            categories={categories}
            toggleFilter={toggleFilter}
            accordionMinusIconSrc={accordionMinusIconSrc}
            accordionPlusIconSrc={accordionPlusIconSrc}
            isOpen={isOpen}
          />
        </div>
        <div className="filter__modal-footer grid-container">
          <div className="grid-x grid-margin-x">
            <div className="cell small-8">
              <Button
                extraClass="filter__modal-button"
                theme="secondary"
                size="large"
                onClick={getOnClickClearAll({ setSelectedFilters, closeModal })}
                link="?filters=[]"
                extraProps={{
                  'data-test': dataTestClearAll,
                }}
              >
                { clearAllText }
              </Button>
            </div>
            <div className="cell small-8">
              <Button
                extraClass="filter__modal-button"
                theme="primary"
                size="large"
                onClick={closeModal}
                extraProps={{
                  'data-test': dataTestApply,
                }}
              >
                { modalFormButtonText }
              </Button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

FilterModal.propTypes = {
  selectedFilters: PropTypes.arrayOf(PropTypes.any),
  closeModal: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.any).isRequired,
  toggleFilter: PropTypes.func.isRequired,
  setSelectedFilters: PropTypes.func.isRequired,
  accordionMinusIconSrc: PropTypes.string.isRequired,
  accordionPlusIconSrc: PropTypes.string.isRequired,
  modalHeadingText: PropTypes.string.isRequired,
  modalCloseIconSrc: PropTypes.string.isRequired,
  clearAllText: PropTypes.string.isRequired,
  modalFormButtonText: PropTypes.string.isRequired,
  dataTestApply: PropTypes.string,
  dataTestClearAll: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
};

export default FilterModal;
